import React, { useState } from 'react'
import glob from '../../Assete/globe-removebg-preview.png'
import { useNavigate } from 'react-router-dom'
import img from '../../Assete/Container.png'
import img1 from '../../Assete/Container (1).png'
import img2 from '../../Assete/Container (2).png'
import img3 from '../../Assete/Container (3).png'
function Banner() {
  const navigate=useNavigate()
  return (
    <div className='banner_home'>
      <div className='banner-content'>
        {/* <img className='globe' src={glob} alt='...' /> */}
        <div className='over-lay'>
          <div className='text-content'>
          <h1>Global <span>Opportunities</span> in Bio-Sciences</h1>
          <p>Discover a world of scholarships and career paths in Biological Sciences. <span style={{color: '#569A44',fontWeight: 'bold'}}>EdFura</span> connects aspiring <br/> biologists to global opportunities — empowering your journey toward scientific excellence.</p>
           <div className='banner_tab mb-3'>
            <div onClick={()=>navigate('/find-new-job')} className='service job_service'>
              <img className='img_job_1' src={img} alt='...'/>
              <img className='img_job_2' src={img3} alt='...'/>
              <h6>Jobs</h6>
              <p className='mb-0'>Browse 10,000+ job opportunities</p>
            </div>
            <div onClick={()=>navigate('/find-new-scholarship')} className='service scholarship_service'>
              <img className='img_job_1' src={img1} alt='...'/>
              <img className='img_job_2' src={img2} alt='...'/>
              <h6>Scholarships</h6>
              <p className='mb-0'>Explore 5,000+ scholarship programs</p>
            </div>
              {/* <button  className={`${"active"} me-2`}>Jobs</button>
              <button  className={`${"active"}`}>Scholar Ship</button> */}
            </div>
      
          </div>
          </div> 
      </div>
    </div>
  )
}

export default Banner